/**
 * index — the SPA browser entry. Mounts the React app into `#root`. This file is
 * the one place that touches the real DOM, so the App + components stay unit
 * testable under happy-dom without a mount side effect.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
